import { render, staticRenderFns } from "./DoctorPicker.vue?vue&type=template&id=4aa824f6&scoped=true"
import script from "./DoctorPicker.vue?vue&type=script&lang=js"
export * from "./DoctorPicker.vue?vue&type=script&lang=js"
import style0 from "./DoctorPicker.vue?vue&type=style&index=0&id=4aa824f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa824f6",
  null
  
)

export default component.exports